module.exports = __webpack_public_path__ + "static/media/IMG_4732.009302fb.JPG";